<template>
  <b-navbar
    fixed-top
    type="is-caxton-orange"
    :mobile-burger="viewMobileBurguer"
  >
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }" class="is-hidden">
        <button class="button ios is-caxton-yellow-light">
          <b-icon icon="chevron-left"></b-icon>
          <span>Inicio</span>
        </button>
      </b-navbar-item>
      <b-navbar-item
        tag="router-link"
        :to="{ path: '/rutas' }"
        class="is-hidden"
      >
        <button class="button ios is-caxton-yellow-light">
          <b-icon icon="chevron-left"></b-icon>
          <span>Rutas</span>
        </button>
      </b-navbar-item>
      <b-navbar-item
        tag="router-link"
        :to="this.$store.getters.navBack.url"
        v-if="this.$store.getters.navBack"
      >
        <button class="button ios is-caxton-yellow-light">
          <b-icon pack="fas" icon="chevron-left"></b-icon>
          <span>{{ this.$store.getters.navBack.text }}</span>
        </button>
      </b-navbar-item>
    </template>
    <template slot="end">
      <b-navbar-item tag="div">
        <div class="columns is-mobile">
          <div class="column has-text-right">
            <h2 class="has-text-weight-medium">
              {{
                $store.getters.detalleruta
                  ? $store.getters.detalleruta.fecha
                  : "" | moment("dddd D MMMM") | capitalize
              }}
            </h2>
          </div>
          <div class="column has-text-right is-narrow">
            <h1 class="has-text-weight-bold">
              {{ $router.currentRoute.name }}
            </h1>
          </div>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  name: "CaxtonNav",
  computed: {
    shownav() {
      return false;
      //return this.$store.getters.shownav;
    },
    islogged() {
      return this.$auth.ready();
      //return this.$store.getters.islogged;
    },
    viewMobileBurguer() {
      return false;
    },
    myroute() {
      return this.$router.currentRoute.path;
    }
  },
  methods: {},
  watch: {
    myroute() {
      console.log("Cambia de estado !");
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value
        .toString()
        .toLowerCase()
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      return value;
    }
  }
};
</script>

<style scoped></style>
